<template>
  <div class="login-container">
    <el-card class="login-card">
      <h2 class="text-center text-xl font-bold mb-6">sharepay 管理后台</h2>
      <el-form ref="form" :model="form" :rules="rules" label-width="0" @submit.native.prevent="onLogin">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="用户名" prefix-icon="el-icon-user" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" placeholder="密码" type="password" prefix-icon="el-icon-lock"
            show-password @keyup.enter.native="onLogin" />
        </el-form-item>
        <el-form-item prop="captchaCode">
          <el-input v-model="form.captchaCode" placeholder="验证码" prefix-icon="el-icon-picture" style="width:60%">
          </el-input>
          <span class="captcha-svg" v-html="captchaSvg" @click="refreshCaptcha" style="float:right;width:35%;height:40px;cursor:pointer" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" style="width:100%" @click="onLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { authApi } from '../api';

export default {
  data() {
    return {
      form: { username: '', password: '', captchaCode: '' },
      captchaSvg: '',
      captchaKey: '',
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        captchaCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
      },
      loading: false
    };
  },
  created() {
    this.refreshCaptcha();
  },
  methods: {
    async refreshCaptcha() {
      const res = await authApi.getCaptcha();
      this.captchaSvg = res.data.svg;
      this.captchaKey = res.data.captchaKey;
      this.form.captchaCode = '';
    },
    async onLogin() {
      try {
        await this.$refs.form.validate();
      } catch (e) { return; }
      this.loading = true;
      try {
        const res = await authApi.login({
          username: this.form.username,
          password: this.form.password,
          captchaKey: this.captchaKey,
          captchaCode: this.form.captchaCode
        });
        const { token, user } = res.data;
        if (user.role !== 'admin') {
          this.$message.error('非管理员账号');
          return;
        }
        this.$store.dispatch('login', { token, user });
        this.$router.replace('/dashboard');
      } catch (e) {
        this.refreshCaptcha();
      } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.login-container {
  display: flex; justify-content: center; align-items: center;
  min-height: 100vh; background: #f0f2f5;
}
.login-card {
  width: 400px; padding: 20px 30px;
}
.captcha-svg >>> svg {
  width: 100%; height: 100%;
}
</style>
